import type { ICollage } from '@/types/Data'
import type { IGetCollageList, IPayloadCollage } from '@/types/Request/PostAPI'
import { JsonToFormData } from '@/utils-ts'
import BaseService from '../BaseService'

export default class CollageServices extends BaseService {
  GetCollageList(data: IGetCollageList) {
    return this.GET<ICollage[]>(this.PATHS.GET_COLLAGE_LIST, data)
  }

  CreateCollage(data: IPayloadCollage) {
    return this.POST<ICollage>(this.PATHS.CREATE_COLLAGE, JsonToFormData(data))
  }

  UpdateCollage(data: IPayloadCollage) {
    return this.PUT<ICollage>(this.PATHS.UPDATE_COLLAGE, JsonToFormData(data))
  }

  DeleteCollage(Id: string) {
    return this.DELETE<void>(this.PATHS.DELETE_COLLAGE, { Id })
  }
}
